import { menuItems } from '../state/modules/menu';

/**
 * Devuelve los subItems del item de menu que contiene el link recibido.
 * Se usa para armar la modal "¿Hacia dónde deseas dirigirte?" a partir de la
 * ruta actual. Antes se filtraba por el label del item padre, que no coincidia
 * con el meta.parent de las rutas y devolvia un array vacio (modal sin opciones).
 */
export const filterMenu = (currentLink) => {
  if (!currentLink) return [];

  const parent = menuItems.find(
    (item) =>
      Array.isArray(item.subItems) &&
      item.subItems.some((sub) => sub.link === currentLink)
  );

  return parent ? parent.subItems : [];
};
